import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-secondary-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="mx-auto px-4 md:px-6 max-w-[1400px]">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            onClick={scrollToTop}
            className="flex items-center gap-2 whitespace-nowrap"
          >
            <span className="text-2xl font-heading text-primary-500">
              43423
            </span>
            <span className="text-sm font-body font-semibold text-foreground-800 hidden sm:inline">
              漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {categories.slice(0, 5).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                onClick={scrollToTop}
                className="px-4 py-2 text-sm text-foreground-600 hover:text-primary-500 rounded-lg hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              onClick={scrollToTop}
              className="px-4 py-2 text-sm text-foreground-600 hover:text-primary-500 rounded-lg hover:bg-primary-50 transition-colors duration-200 whitespace-nowrap"
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <div className="relative">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                type="text"
                placeholder="搜索漫画..."
                className="pl-9 pr-4 py-2 text-sm bg-secondary-100 border border-secondary-200 rounded-full w-48 focus:w-64 transition-all duration-300 focus:outline-none focus:border-primary-300 focus:bg-background-50 text-foreground-700 placeholder:text-foreground-400"
              />
            </div>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-secondary-200/60">
          <div className="px-4 py-3 space-y-1">
            <div className="relative mb-3">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-sm"></i>
              <input
                type="text"
                placeholder="搜索漫画..."
                className="w-full pl-9 pr-4 py-2 text-sm bg-secondary-100 border border-secondary-200 rounded-full focus:outline-none focus:border-primary-300 text-foreground-700 placeholder:text-foreground-400"
              />
            </div>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                onClick={() => {
                  setMobileMenuOpen(false);
                  scrollToTop();
                }}
                className="block px-4 py-2.5 text-sm text-foreground-600 hover:text-primary-500 hover:bg-primary-50 rounded-lg transition-colors duration-200"
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              onClick={() => {
                setMobileMenuOpen(false);
                scrollToTop();
              }}
              className="block px-4 py-2.5 text-sm text-foreground-600 hover:text-primary-500 hover:bg-primary-50 rounded-lg transition-colors duration-200"
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}